export const SPACERS = {
  // Variables
  resetZero: '0',
  extraLarge: '40px',
  xExtraLarge: '48px',
  large: '32px',
  medium: '24px',
  small: '16px',
  tiny: '8px',
  extraTiny: '4px',

  // border-spacing
  borderMain: '1px solid grey-base',
  borderRadiusMain: '4px',
};
